import { Component , Injector }                 from '@angular/core';
import { Sort }                                 from '@angular/material/sort';
import { LoggedBaseComponent }                  from './LoggedBaseComponent';

@Component({
  selector      : 'PageableComponent',
  templateUrl   : 'PageableComponent.html',
})
export class PageableComponent extends LoggedBaseComponent
{
    loading                         = false;
    total_rows                      = 0;
    per_page                        = 20;
    page_number                     = 1;

    order_info                      = {};

    page_callback                   = undefined;

    constructor(pageable_injector: Injector)
    {
        super(pageable_injector);
        this.sortData = this.sortData.bind(this);
    }

    setPageChangeCallback(callback)
    {
        this.page_callback = callback;
    }

    onPaginateChange(event)
    {
        this.per_page       = event.pageSize;
        this.page_number    = event.pageIndex + 1;
        if (this.page_callback !== undefined)
        {
            this.page_callback();
        }
    }

    addOrdering(key, order_verse)
    {
        this.order_info = { "ob" : key , "ov" : order_verse };
    }

    sortData(sort: Sort) {
        this.addOrdering(sort.active,sort.direction);
        this.page_callback();
      }
}
